import { styled } from "@linaria/react";
import { SIZE_L, SIZE_M, SIZE_S } from "../../constants";
export const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1xve3c2"
});
export const H1 = /*#__PURE__*/styled("h1")({
  name: "H1",
  class: "h1fe6uox"
});

require("../../../.linaria-cache/src/components/contentPage/index.linaria.module.css");